import React, { useState } from 'react';
import { Box, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
 
import styles from './LayoutOutside.module.scss'; // SCSS module for layout
import HeaderOutside from '../Header/HeaderOutside';
 

interface LayoutProps {
  children: React.ReactNode;
}

// Basic MUI theme (you can customize this further)
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90CAF9', // Lighter blue for dark mode
    },
    background: {
      default: '#121212',
      paper: '#1E1E1E',
    },
  },
});

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#6200EE',
    },
    background: {
      default: '#F8F9FF',
      paper: '#ffffff',
    },
  },
});


const LayoutOutside: React.FC<LayoutProps> = ({ children }) => {
  const [open, setOpen] = useState(true); // State for sidebar open/close
  const [darkMode, setDarkMode] = useState(false);

  const handleDrawerToggle = () => {
    setOpen(!open);
    localStorage.setItem('sidebarOpen', JSON.stringify(!open));
  };

  const handleThemeToggle = () => {
    setDarkMode(!darkMode);
  };

  const currentTheme = darkMode ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline /> {/* Applies base Material-UI styles */}
      <Box  >
        <HeaderOutside
 
        />
        <Box
          component="main"
          className={styles.mainContent}
          sx={{
            flexGrow: 1,
            p: 0,
            transition: 'margin-left 0.3s ease',
 
          }}
        >
          {children}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default LayoutOutside;